
import Vue from 'vue';
import Card from '@/components/Card/index.vue';
import { getAllQuestion } from '@/services/territory/get-all-question';
import { GetAllQuestionParams } from '@/config/types';
import { capitalizeFirstLetter } from '@/utils/capitalize-first-letter';
import { Container, Main } from './styles';

export default Vue.extend({
  name: 'Autovistoria',
  props: ['car', 'dataInitial', 'dataEnd'],
  components: {
    Card,
    Container,
    Main,
  },
  data() {
    return {
      title: 'Autovistoria',

      questions: [] as number[],
      userLogged: JSON.parse(sessionStorage.getItem('userLogged') as string),
    };
  },
  methods: {
    async getQuestions() {
      const { idUser, company } = this.userLogged;

      const params: GetAllQuestionParams = {
        vlTitle: '',
        fkUser: idUser, // Valor de teste = 5483
        dtStart: '',
        dtEnd: '',
        territory: '',
        agent: '',
        fkQuiz: -1,
        status: 'finalizado',
        tokenKey: company.stKey,
        fkCompany: company.idCompany,
        limited: false,
      };

      const { objectResult: questions } = await getAllQuestion(params);
      return (
        questions?.map((question: any) => ({
          cdEvidence: question.cdEvidence,
          vlTitle: capitalizeFirstLetter(question.vlTitle),
        })) || []
      );
    },
  },
  async created() {
    this.questions = await this.getQuestions();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const routes = [
        { name: from.meta?.bradcrumb, path: from.path },
        { name: to.meta?.bradcrumb, path: to.path },
      ];
      vm.$store.commit('setRoutes', routes);
    });
  },
});
